import * as turf from '@turf/turf'



// Wymaga: npm install @turf/turf
import bboxPolygon from '@turf/bbox-polygon';
import proj4 from 'proj4';

// Definicje układów współrzędnych
const WGS84 = 'EPSG:4326';
const WEB_MERCATOR = 'EPSG:3857';
const EPSG = 'EPSG:3857';


// Funkcja do konwersji pojedynczego punktu
function projectCoord(coord, from, to) {
  return proj4(from, to, coord);
}

export function get10mBoundingBox(feature) {
  // Wyznaczenie bounding box w WGS84
  const [minX, minY, maxX, maxY] = turf.bbox(feature);

  // Konwersja do metrów (Web Mercator)
  const [minXM, minYM] = projectCoord([minX, minY], WGS84, EPSG);
  const [maxXM, maxYM] = projectCoord([maxX, maxY], WGS84, EPSG);

  let width = maxXM - minXM;
  let height = maxYM - minYM;

  
  // Zaokrąglenie do wielokrotności 10 m
  const step = 10;
  let sidex = Math.ceil(width / step) * step;
  let sidey = Math.ceil(height / step) * step;

  // Wycentrowanie kwadratu
  const centerX = (minXM + maxXM) / 2;
  const centerY = (minYM + maxYM) / 2;
  const halfx = sidex / 2;
  const halfy = sidey / 2;

  const minXSquare = centerX - halfx;
  const minYSquare = centerY - halfy;
  const maxXSquare = centerX + halfx;
  const maxYSquare = centerY + halfy;

  // Konwersja z powrotem do WGS84
  const [minXdeg, minYdeg] = projectCoord([minXSquare, minYSquare], EPSG, WGS84);
  const [maxXdeg, maxYdeg] = projectCoord([maxXSquare, maxYSquare], EPSG, WGS84);

  // Zwracam współrzędne
  return ([minXdeg, minYdeg, maxXdeg, maxYdeg]);
}




export function getBBoxWidthAndHeight(feature, step=10) {
  // Wyznaczenie bounding box w WGS84
  const [minX, minY, maxX, maxY] = turf.bbox(feature);


  let width = maxX - minX;
  let height = maxY - minY;
  //console.log("minX " + minX + "minY "+minY);
  var point=turf.point([minX,minY]);
  var north=turf.destination(point,step/1000.0,0,{ units: "kilometers" })
  var east=turf.destination(point,step/1000.0,90,{ units: "kilometers" })  
  

  var stepeast=east.geometry.coordinates[0]-point.geometry.coordinates[0];
  var stepnorth=north.geometry.coordinates[1]-point.geometry.coordinates[1];

  
  let x= Math.ceil(width/stepeast); //ile pozycji w poziomie
  let y= Math.ceil(height/stepnorth); //ile pozycji w pionie

  //console.log("x " + x + " y "+ y);

  return ([stepeast, stepnorth, x, y]);
}


export function generateGrid(bbox, step = 10) {
  // Konwersja bbox do metrów
  //console.log("bbox");
  //console.log(bbox);
  const [minX, minY, maxX, maxY] = bbox;
  /*
  console.log("grid mins max");
  console.log(minX);
  console.log(minY);
  console.log(maxX);
  console.log(maxY);
  */
  
  var point=turf.point([minX,minY]);
  var north=turf.destination(point,step/1000.0,0,{ units: "kilometers" })
  var east=turf.destination(point,step/1000.0,90,{ units: "kilometers" })  
  var stepeast=east.geometry.coordinates[0]-point.geometry.coordinates[0];
  var stepnorth=north.geometry.coordinates[1]-point.geometry.coordinates[1];


  const features = [];

  // Iteracja po siatce
  for (let y = minY; y < maxY; y += stepnorth) {
    for (let x = minX; x < maxX; x += stepeast) {
      const coord = [
        [x, y],
        [x + stepeast, y],
        [x + stepeast, y + stepnorth],
        [x, y + stepnorth],
        [x, y] // zamknięcie pierścienia
      ];


      // Tworzenie feature
      features.push(
        turf.polygon([coord], { index: features.length })
      );
    }
  }

  return turf.featureCollection(features);
}






export function resizeBoundingBox(bounds) {
    var point1 = turf.point([bounds[0], bounds[1]]);
    var point2 = turf.point([bounds[2], bounds[3]]);
    var bearing = turf.bearing(point1, point2);
    var distance = turf.distance(point1, point2);
    var p1 = turf.destination(point1, -0.2 * distance, bearing);
    var p2 = turf.destination(point2, 0.2 * distance, bearing);
    var box = [p1.geometry.coordinates[0], p1.geometry.coordinates[1], p2.geometry.coordinates[0], p2.geometry.coordinates[1]];
    return box;
}


export function applyFeatrueCollection(collection) {
    localStorage.setItem('featureCollection', JSON.stringify(collection));
    dispatchEvent(new Event("featureCollectionChanged"));
}

export function applyBoundingBox(bounds) {
    localStorage.setItem('boundingBox', JSON.stringify(bounds));
    dispatchEvent(new Event('boundingBoxChanged',bounds));
}


export function showFields(fields) {
    let features = [];
    fields.forEach(field => {
        let shape=JSON.parse(field.shape);
        if (shape.type=="feature") features.push(shape);
        if (shape.type=="FeatureCollection") {
            shape.features.forEach(feature => features.push(feature));
        } 
        console.log('shape');
        console.log(shape);
        features.push();
    });

    showFeatures(features);
}


export function focusOnFeature(feature) {
    if (!feature) return;
    if (feature.type!="Feature") 
        {
            console.log('this is not feature!');
            return;
        }

    let bounds = turf.bbox(feature);
    let resizedbounds= resizeBoundingBox(bounds);

    applyBoundingBox(resizedbounds);
}


export function showFeature(feature) {
    if (!feature) return;
    if (feature.type!="Feature") 
        {
            console.log('this is not feature!');
            return;
        }

    let collection = {
        "type": "FeatureCollection",
        features: [feature]
    }

    let bounds = turf.bbox(collection);
    let resizedbounds= resizeBoundingBox(bounds);
    
    applyFeatrueCollection(collection);
    applyBoundingBox(resizedbounds);
}




export function showFeatures(features) {
    if (!Array.isArray(features)) 
    {
        console.log('Array of Featrues was expected!');
        return;
    }
    if (features.length==0) 
    {
        console.log('Empty Array of Features!');
        return;
    }

    let collection = {
        "type": "FeatureCollection",
        features: features
    }
    try 
    {
    console.log('collection');
    console.log(collection);
    let bounds = turf.bbox(collection);
    let resizedbounds= resizeBoundingBox(bounds);
    
    applyFeatrueCollection(collection);
    applyBoundingBox(resizedbounds);
    } catch { console.log('error at showFeatures'); }
}


export function focusOnFeatures(features) {
    if (!Array.isArray(features)) 
    {
        console.log('Array of Featrues was expected!');
        return;
    }
    if (features.length==0) 
    {
        console.log('Empty Array of Features!');
        return;
    }

    let collection = {
        "type": "FeatureCollection",
        features: features
    }

    let bounds = turf.bbox(collection);
    let resizedbounds= resizeBoundingBox(bounds);
    
    applyBoundingBox(resizedbounds);
}


export function showGeoJson(feature) {
    if (!feature) return;
    console.log('feature');
    console.log(feature);

    let collection = {
        "type": "FeatureCollection",
        features: [feature]
    }

    console.log('collection');
    console.log(collection);

    //let area = turf.area(feature) / 10000.0;
    let bounds = turf.bbox(feature);

    //let center = turf.center(feature);
    let resizedbounds= resizeBoundingBox(bounds);
    
    applyFeatrueCollection(collection);
    applyBoundingBox(resizedbounds);

}


export function matchFieldsResults(fields, results, timestamp, fileid, callback) {

    for (var j=0; j<results.features.length;j++)
        {
            results.features[j].area=turf.area(results.features[j]); //in square meters (m2)
        }


    for (var i=0; i<fields.features.length;i++)  {
      fields.features[i].area=turf.area(fields.features[i]); //in square meters (m2)
      fields.features[i].exam_area=0;
      fields.features[i].intersections=0;  
      fields.features[i].overlaps=0;    
        for (var j=0; j<results.features.length;j++)
        {
            try
            {
            var intersection = turf.intersect(fields.features[i], results.features[j]); 
                if (intersection)       
                {
                    fields.features[i].exam_area+=results.features[j].area;
                    fields.features[i].intersections+=1;
                    fields.features[i].overlaps+=1;
                    results.features[j].assigned_to=i+1;
                }
            } catch (ex) {
                console.log('exception at intersection');
                console.log(intersection);
                console.log(ex);

            }
        } //for j
        var examvalue=fields.features[i].exam_area/fields.features[i].area;
        if (examvalue>=0.999) examvalue=1.0;
        var exam_percent = Math.round(examvalue*10000)/100;
        fields.features[i].exam_percent = exam_percent;
        fields.features[i].area=Math.round(fields.features[i].area/100)/100;
        fields.features[i].examtime = timestamp;
        let examobj={ fileid: fileid, timestamp: timestamp, percent: exam_percent };
        

        if (examvalue>0.5) 
        {
            if (!Array.isArray(fields.features[i].examined)) fields.features[i].examined=[examobj];
            else
            {
                
                console.log("Checking i=" + i);
                if (!fields.features[i].examined.some(e => e.timestamp === timestamp)) {
                    fields.features[i].examined.push(examobj);
                    console.log('not contains');
                }
                else
                {
                    var exami = fields.features[i].examined.findIndex(exam => {return exam.timestamp === timestamp});
                    if (exami>=0) fields.features[i].examined[exami]=examobj;

                }
                //if (!fields.features[i].examined.timestamp.includes(timestamp)) fields.features[i].examined.push(examobj);
            }
        }
        delete fields.features[i].exam_area;
        
    } //for i
    if (callback) callback(fields,results);



}